import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getApiHeader } from 'utlis/commonfunctions';
import done from '../../../../assets/images/done.png';
import DropIn from 'braintree-web-drop-in-react';
import {
    Alert,
    Card,
    CardHeader,
    CardContent,
    Grid,
    Box,
    Collapse,
    IconButton,
    AlertTitle,
    Backdrop,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const Payment = ({ paymentMethodToken, onPaymentSubmit }) => {
    const [clientToken, setClientToken] = useState('');
    const [loading, setLoading] = useState(true);
    const [paymentSubmit, setpaymentSubmit] = useState(false)
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const [paymentStatus, setPaymentStatus] = useState(true);
    const [agreedToTerms, setAgreedToTerms] = useState(false);

    const [defaultCard, setdefaultCard] = useState([]);
    const [existingCard, setExistingCard] = useState(0);

    const instanceRef = useRef(null); 

    const styles = {
        enhancedShimmerCard: {
            width: '100%',
            maxWidth: '700px',
            margin: '20px auto',
            borderRadius: '12px',
            overflow: 'hidden',
            background: '#f6f7f9',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            padding: '16px',
        },
        shimmerHeader: {
            height: '60px',
            width: '100%',
            background: 'linear-gradient(to right, #e0e0e0 8%, #f2f2f2 18%, #e0e0e0 33%)',
            borderRadius: '8px',
            animation: 'shimmer 3.5s infinite',
            marginBottom: '16px',
        },
        shimmerBody: {
            height: '280px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
        },
        shimmerLine: {
            height: '20px',
            width: '100%',
            background: 'linear-gradient(to right, #e0e0e0 8%, #f2f2f2 18%, #e0e0e0 33%)',
            borderRadius: '4px',
            animation: 'shimmer 3.5s infinite',
        },
        shimmerButton: {
            marginTop: '20px',
            height: '40px',
            width: '100%',
            background: 'linear-gradient(to right, #e0e0e0 8%, #f2f2f2 18%, #e0e0e0 33%)',
            borderRadius: '8px',
            animation: 'shimmer 3.5s infinite',
        },
    };

    const handleCheckboxChange = (event) => {
        setAgreedToTerms(event.target.checked);
    };

    const fetchToken = async () => {
        setLoading(true);
        const headers = await getApiHeader();
        try {
            const response = await axios.get(`${apiUrl}international-esim/esim-checkout-payment/${paymentMethodToken}`, {
                headers: headers,
            });

           

            const paymentMethods = response?.data?.data?.payment_methods;

            if (Array.isArray(paymentMethods) && paymentMethods.length > 0) {
               
                setdefaultCard(paymentMethods); 
                setExistingCard(1); 
            } else if (typeof paymentMethods === "object" && paymentMethods !== null) {
              
                setdefaultCard(paymentMethods);
                setExistingCard(1);
            } else {
              
                const clientToken = response?.data?.data?.client_token || null;
                setClientToken(clientToken);
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const handleSubmit = () => {

        if (existingCard === 1) {
            handlePaymentSubmitWithDefaultCard();
        } else {
            handlePaymentSubmitWithoutDefaultCard();
        }
    };

    const handlePaymentSubmitWithDefaultCard = async () => {
        const headers = await getApiHeader();
        try {
            setLoading(true);
            const response = await axios.post(`${apiUrl}international-esim/esim-checkout-payment-submit`, { 'payment_method_token': paymentMethodToken }, { headers: headers });

            if (response?.status === 200) {
                console.log("Default Card Payment Success:", response?.data?.data?.data);
                onPaymentSubmit(response?.data?.data?.data);
            } else {
                console.error("Default Card Payment Failed:", response?.data);
                alert("Payment failed. Please try again.");
            }
        } catch (error) {
            console.error("Default Card Payment Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePaymentSubmitWithoutDefaultCard = async () => {
        setpaymentSubmit(true)
        const headers = await getApiHeader();
        if(paymentStatus === 1 && existingCard===0){
            if (!instanceRef.current) return;
        }
       
        if (instanceRef.current) {
            try {
               
                let nonce = null;
                if (instanceRef.current ) {
                    const paymentMethod = await instanceRef.current.requestPaymentMethod();
                    nonce = paymentMethod.nonce;
                }

                const response = await axios.post(
                    `${apiUrl}international-esim/esim-checkout-payment-submit`,
                    { payment_method_nonce: nonce , payment_method_token : paymentMethodToken }, // Use nonce here
                    { headers: headers }
                );

                if (response?.status === 200) {
                    console.log("Payment Success:", response?.data);
                    setpaymentSubmit(false);
                    onPaymentSubmit(response?.data?.data?.data);
                    
                } else {
                    setpaymentSubmit(false);
                    console.error("Payment Failed:", response?.data);
                    alert("Payment failed. Please try again.");
                }
            } catch (error) {
                setpaymentSubmit(false);
                console.error("Payment Error:", error);
                alert("Payment failed. Please add your card details.");
            } finally {
                setpaymentSubmit(false);
            }
        }
    };

    useEffect(() => {
        fetchToken();
    }, []);

    return (
        <>
            {loading ? (
                <Backdrop
                open={true}
                style={{
                    color: "#fff",
                    zIndex: 9999,
                }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            ) : (
                <Card sx={{ boxShadow: 3 }}>
                    <CardHeader
                        title="Payment Section"
                        sx={{
                            textAlign: "center",
                            backgroundColor: "#c11d6c",
                            color: "#fff!important",
                        }}
                        titleTypographyProps={{ style: { color: "white", fontSize: "24px" } }}
                    />
                    <CardContent>
                        {paymentStatus && (
                            <div className="pay-btree-block">
                                <span className="amount-mention">*All amounts are mentioned in AUD </span>
                                {defaultCard && existingCard === 1 ? (
                                    <div className="defaultCard col-lg-12">
                                        <div className="defaultCardBox">
                                            <p>Paying With Card</p>
                                            <ul className="defaultCardDetails">
                                                <li>
                                                    <img src={defaultCard.imageUrl} alt="Card" />
                                                </li>
                                                <li>
                                                    <span>Ending In {defaultCard.last4}</span>
                                                    <span>{defaultCard.cardType}</span>
                                                </li>
                                                <li>
                                                    <img src={done} alt="Done" />
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                ) : (
                                    clientToken && (
                                        <DropIn
                                            options={{ authorization: clientToken }}
                                            onInstance={(instance) => (instanceRef.current = instance)} // This is correct
                                        />
                                    )
                                )}
                            </div>
                        )}
                        <div className="pay-btree-block">
                            <label className="check-box add-mb-accept-pay">
                                I have read and accept the{' '}
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.telsim.com.au/website-terms-conditions/"
                                >
                                    Terms & Conditions
                                </a>
                                , the Acceptable Use Policy, the{' '}
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.telsim.com.au/website-privacy-policy/"
                                >
                                    Privacy Policy
                                </a>
                                and the{' '}
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.telsim.com.au/website-terms-conditions/"
                                >
                                    Refund Policy
                                </a>
                                .
                                <input type="checkbox" required="" id="agreeTerms" checked={agreedToTerms}
                                            onChange={handleCheckboxChange} title="Please check and agree to the terms and conditions" />
                                        <span className="tick"></span>
                            </label>
                        </div>
                        <div className="btn-payment">
                            <button
                                disabled={!agreedToTerms  || paymentSubmit}
                                onClick={handleSubmit}
                                className="btn btn-block w-100"
                                style={{ backgroundColor: "#c11d6c", color: "white" }}
                            >
                               { paymentSubmit ? 'Payment In progress...' : "Pay Now" } 
                            </button>
                        </div>
                    </CardContent>
                </Card>
            )}
        </>
    );
};

export default Payment;
